import { CardTest } from "../styles/Card";

const ViewNumberEight = ({ formInvest, setFormInvest }) => {
  // Choice One
  const onChangeChoiceOne = (e) => {
    let value = e.target.value;
    if (value === "one") {
      setFormInvest({
        ...formInvest,
        eigth_question_choice_one: true,
        eigth_question_choice_two: false,
        eigth_question_choice_three: false,
        eigth_question_choice_four: false,
      });
    }
  };

  // Choice Two
  const onChangeChoiceTwo = (e) => {
    let value = e.target.value;
    if (value === "two") {
      setFormInvest({
        ...formInvest,
        eigth_question_choice_one: false,
        eigth_question_choice_two: true,
        eigth_question_choice_three: false,
        eigth_question_choice_four: false,
      });
    }
  };

  // Choice Three
  const onChangeChoiceThree = (e) => {
    let value = e.target.value;
    if (value === "three") {
      setFormInvest({
        ...formInvest,
        eigth_question_choice_one: false,
        eigth_question_choice_two: false,
        eigth_question_choice_three: true,
        eigth_question_choice_four: false,
      });
    }
  };

  // Choice Four
  const onChangeChoiceFour = (e) => {
    let value = e.target.value;
    if (value === "four") {
      setFormInvest({
        ...formInvest,
        eigth_question_choice_one: false,
        eigth_question_choice_two: false,
        eigth_question_choice_three: false,
        eigth_question_choice_four: true,
      });
    }
  };

  return (
    <div className=" bg-gray50 p-4 mt-5 rounded-[10px] ">
      <div className=" text-maincyan text-xs">คำถามที่ 8 จาก 10</div>
      <CardTest
        choice1={<div>กังวลและตื่นตระหนกกลัวขาดทุน</div>}
        choice2={<div>ไม่สบายใจแต่พอเข้าใจได้บ้าง</div>}
        choice3={<div>เข้าใจและรับความผันผวนได้ ในระดับหนึ่ง</div>}
        choice4={
          <div>
            ไม่กังวลกับโอกาสขาดทุนสูงและหวัง กับผลตอบแทนที่อาจจะได้รับสูงขึ้น
          </div>
        }
        value1={"one"}
        value2={"two"}
        value3={"three"}
        value4={"four"}
        onChange1={onChangeChoiceOne}
        onChange2={onChangeChoiceTwo}
        onChange3={onChangeChoiceThree}
        onChange4={onChangeChoiceFour}
        checked1={formInvest?.eigth_question_choice_one}
        checked2={formInvest?.eigth_question_choice_two}
        checked3={formInvest?.eigth_question_choice_three}
        checked4={formInvest?.eigth_question_choice_four}
        question="8. ถ้าท่านเลือกลงทุนในทรัพย์สินที่มีโอกาสได้
        รับผลตอบแทนมากแต่มีโอกาสขาดทุนสูงด้วย
        เช่นกัน ท่านจะรู้สึกอย่างไร"
      />
    </div>
  );
};

export default ViewNumberEight;
